// extracted by mini-css-extract-plugin
export default {"columnTitle":"historyMobile_columnTitle__npRwM","element":"historyMobile_element__D4qbY","datapoint":"historyMobile_datapoint__FUMbm"};